
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-payment",
      function () {
        return require("private-next-pages/success-payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-payment"])
      });
    }
  